/*global angular */
'use strict';

angular.module('MrDWebApp').controller('OrderExceptionCtrl', function ($scope, $state) {

  switch ($scope.exceptionOrder.status) {
    case 'failed_collection':
    case 'failed_delivery':
    case 'cancelled':
    case 'failed_delivery_injection':
      $scope.refundShow = '';
      break;
  
    default:
      $scope.refundShow = $scope.exceptionOrder.payment.refunded_to;
      break;
  }
  
  //$scope.refundShow = 'credit'; //test other refund detail blocks

  // $scope.refundShow = ''; // default: hidden refund details
  // var p = $scope.exceptionOrder.payment;
  // if (p.type === 'credit' || p.type === 'instant_eft' || p.type === 'wallet') {
  //   if (p.refunded_to === 'wallet' && p.amount_refunded) {
  //     $scope.refundShow = 'wallet';
  //   } else if (p.type === 'credit') {
  //     $scope.refundShow = 'bank';
  //   } else {
  //     // hide refund detail
  //   }
  // } else if (p.type === 'ebucks') {
  //   $scope.refundShow = 'ebucks';
  // } else if (p.type === 'cash') {
  //   // hide refund detail
  // } else {
  //   // hide refund detail
  // }

  $scope.showInfoWallet = false;
  $scope.showInfoPayout = false;

  $scope.infoWallet = function(){
    $scope.showInfoWallet = true;
    $scope.showInfoPayout = false;
  };
  $scope.infoPayout = function(){
    $scope.showInfoWallet = false;
    $scope.showInfoPayout = true;
  };
  $scope.closeInfo = function(){
    $scope.showInfoWallet = false;
    $scope.showInfoPayout = false;
  };

  $scope.action = function(id){
    // console.log("command",id)
    switch (id) {
      case 'cmd_new_restaurant':
        $scope._rc.newOrderSoft();
        if ($scope._rc.variables.address.street_name){ // check for only street-name here. Assuming the rest..
          $state.go('location',{
            lat: $scope._rc.variables.address.latitude,
            lng: $scope._rc.variables.address.longitude,
            street_name: $scope._rc.variables.address.street_name
          });
        } else {
          if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
        }
        break;
    
    }

    
  };


});
